/**
 *
 * AddressFormInput: Generic component to display a form that can edit a AddressInput, has no server logic and client side validation logic
 * CreateDeliveryAddressForm: Wrapps the AddressFormInput and ha
 *
 *
 */
import {Address, AddressInput} from "@/shared/graphql/types";
import yup from "@/shared/composable/validationMessages.ts";

export const addressToInput = (address?: Address): AddressInput => {
    if (address) {
        return {
            company: address.company,
            street: address.street,
            houseNumber: address.houseNumber,
            busNumber: address.busNumber,
            zipCode: address.zipCode,
            city: address.city,
            country: address.country?.code,
            extra: address.extra
        }
    }
    return {
        company: "",
        street: "",
        houseNumber: "",
        busNumber: "",
        zipCode: "",
        city: "",
        country: "BE",
        extra: ""
    };
}

export const defaultAddressValidationSchema = (isHouseNumberSeparate: boolean) => {
    return yup.object().shape({
        id: yup.mixed(),
        city: yup.string().required(),
        busNumber: yup.string(),
        country: yup.string().required().length(2),
        company: yup.string(),
        houseNumber: yup.string().when([], () => (isHouseNumberSeparate ? yup.string().required() : yup.string().nullable())),
        street: yup.string().required(),
        zipCode: yup.string().required(),
        extra: yup.string(),
    });
}